module.exports = __webpack_public_path__ + "static/media/01.0f84cfe8.jpg";